import { useState } from "react";
import { useDispatch } from 'react-redux';

import AdminTroubleComponentCont from "./AdminProcessCont";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';
import useAccess from "../../hooks/useAccess";
import LoadingComponent from "../Commons/LoadingComponent";

import { getLabel } from "../../tools/Dictionary";

import "./AdminProcess.css";

const AdminProcessPage = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;

  //Redux
  const Dispatch = useDispatch();
  const Access = useAccess(["Ad_Trouble"]);

  //state
  const [loading, setLoading] = useState(false);

  //Variables
  const component = "AdminProcessPage";



  useMount(() =>
  {
    Dispatch(setCurrentNavigation("Tr_Process"));
  }, []);

  if (!Access.canRead)
    return (
      <div className="page_cont">
        <div className="page_message_text">
          {getLabel("App", "Access Denied: You don't have...")}
        </div>
      </div>
    );

  return (
    <div className="page_cont">
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <div className="page_title">
        {getLabel(component, "Troubleshoot Process")}
      </div>
      <AdminTroubleComponentCont IsDesktop={IsDesktop} ParentLoading={loading} setParentLoading={setLoading} Access={Access} />
    </div>
  )

};

export default AdminProcessPage;